export var PrintTemplateType;
(function (PrintTemplateType) {
    PrintTemplateType["RESERVATION_CONFIRMATION"] = "RESERVATION_CONFIRMATION";
    PrintTemplateType["FOLIO_CONFIRMATION"] = "FOLIO_CONFIRMATION";
    PrintTemplateType["AGENDA_HANDOUT"] = "AGENDA_HANDOUT";
    PrintTemplateType["OTHER"] = "OTHER";
})(PrintTemplateType || (PrintTemplateType = {}));
